import React from 'react'
import { useTranslation } from 'react-i18next'
import { Message } from 'semantic-ui-react'
import Dialog from '~/components/Dialog'
import { formatNumber } from '~/utils/helpers'

interface Props {
  energyCalcData: any
  isEnergyModalOpen: boolean
  handleClose: () => void
}

const EnergyModal: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { energyCalcData, isEnergyModalOpen, handleClose } = props

  function getMessage() {
    const totalEnergyWithAddition = `${formatNumber(energyCalcData?.totalEnergyWithAddition, 0)} MJ NEL/Jahr`
    const totalEnergy = `${formatNumber(energyCalcData?.totalEnergy, 0)} MJ NEL/Jahr`
    const energyAddition = `${formatNumber(energyCalcData?.energyAddition, 2)} %`
    if (energyCalcData?.energyAddition < 0) {
      return <Message error>
        <p>
          <div>{`Aus der von Ihnen eingegebenen Futterration errechnet sich ein Futterenergiegehalt von ${totalEnergyWithAddition}.`}</div>
          <div>{`Der Gesamtenergiebedarf je Kuh liegt bei ${totalEnergy}.`}</div>
          <div>{'Daraus ergibt sich laut  LfL Berechnung ein'} <div style={{ fontWeight: 'bold' }}>{`Optimierungspotential von ${energyAddition}.`}</div></div>
          <div>{'Aufgrund einer Vorgabe des LfL-Rechners darf das Optimierungspotential nicht negativ sein.'}</div>
          <div>{'Bitte kontrollieren Sie nochmal Ihre Futterration. Die THG Emissionsberechnung kann nicht abgeschlossen werden.'}</div>
        </p>
      </Message>

    } else if (energyCalcData?.energyAddition >= 100) {
      return <Message error>
        <p>
          <div>{`Aus der von Ihnen eingegebenen Futterration errechnet sich ein Futterenergiegehalt von ${totalEnergyWithAddition}.`}</div>
          <div>{`Der Gesamtenergiebedarf je Kuh liegt bei ${totalEnergy}.`}</div>
          <div>{'Daraus ergibt sich laut  LfL Berechnung ein'} <div style={{ fontWeight: 'bold' }}>{`Optimierungspotential von ${energyAddition}.`}</div></div>
          <div>{'Aufgrund einer Vorgabe des LfL-Rechners darf das Optimierungspotential nicht größer 100% sein.'}</div>
          <div>{'Bitte kontrollieren Sie nochmal Ihre Futterration. Die THG Emissionsberechnung kann nicht abgeschlossen werden.'}</div>
        </p>
      </Message>
    }
    else if (energyCalcData?.energyAddition > 30) {
      return <Message warning>
        <p>
          <div>{`Aus der von Ihnen eingegebenen Futterration errechnet sich ein Futterenergiegehalt von ${totalEnergyWithAddition}.`}</div>
          <div>{`Der Gesamtenergiebedarf je Kuh liegt bei ${totalEnergy}.`}</div>
          <div>{'Daraus ergibt sich laut  LfL Berechnung ein'} <div style={{ fontWeight: 'bold' }}>{`Optimierungspotential von ${energyAddition}.`}</div></div>
          <div>{'Bitte kontrollieren Sie nochmal Ihre eingegebene Futterration auf Plausibilität, da das Optimierungspotential'} <span style={{ textDecoration: 'underline' }}>{'sehr hoch'}</span>{' ist.'}</div>
          <div>{'Sie können die THG Emissionsberechnung dennoch abschließen.'}</div>
        </p>
      </Message>
    }
    return <Message success>
      <p>
        <div>{`Aus der von Ihnen eingegebenen Futterration errechnet sich ein Futterenergiegehalt von ${totalEnergyWithAddition}.`}</div>
        <div>{`Der Gesamtenergiebedarf je Kuh liegt bei ${totalEnergy}.`}</div>
        <div>{'Daraus ergibt sich laut  LfL Berechnung ein'} <div style={{ fontWeight: 'bold' }}>{`Optimierungspotential von ${energyAddition}.`}</div></div>
        <div>{'Sie können die THG Emissionsberechnung nun abschließen.'}</div>
      </p>
    </Message>
  }

  return <Dialog
    open={isEnergyModalOpen && energyCalcData}
    handleClose={() => handleClose()}
    textHeader={t('Feed energy requirements')}
    textClose={t('Close the window')}
    textContent={<div style={{ textAlign: 'center' }}>
      {getMessage()}
    </div>
    }
  />
}
export default EnergyModal